export const categories = [
  {
    id: "entertainment",
    name: "娱乐",
    icon: "ri-movie-2-line",
    description: "综艺名场面、短剧与高能瞬间，轻松get全网最热的娱乐话题。",
  },
  {
    id: "life",
    name: "生活",
    icon: "ri-leaf-line",
    description: "治愈日常、城市风光与户外旅拍，发现生活里的小确幸。",
  },
  {
    id: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    description: "原创弹唱、电音混音与古风编曲，用旋律填满每一次刷屏。",
  },
  {
    id: "food",
    name: "美食",
    icon: "ri-restaurant-2-line",
    description: "家常教程与街头探店，深夜慎点，越看越饿。",
  },
  {
    id: "funny",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    description: "萌宠迷惑行为与沙雕日常，三秒钟把你逗笑。",
  },
  {
    id: "game",
    name: "游戏",
    icon: "ri-gamepad-line",
    description: "高光操作与速通挑战，属于玩家的热血时刻。",
  },
];

export const videos = [
  {
    id: "v01",
    title: "城市夜景延时摄影：霓虹之下的深夜浪漫",
    categoryId: "life",
    categoryName: "生活",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20city%20skyline%20at%20night%20with%20glowing%20red%20and%20warm%20neon%20lights%2C%20long%20exposure%20car%20light%20trails%2C%20cinematic%20urban%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-01&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20city%20skyline%20at%20night%20with%20glowing%20red%20and%20warm%20neon%20lights%2C%20long%20exposure%20car%20light%20trails%2C%20cinematic%20urban%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-01&orientation=landscape",
    duration: "00:48",
    plays: 1286000,
    likes: 92300,
    author: "夜行摄影师",
    publishedAt: "2026-10-12",
    description: "用一组延时镜头记录城市入夜的全过程，霓虹、车流与晚风，构成了这座城最温柔的一面。",
    tags: ["延时摄影", "城市风光", "夜景"],
  },
  {
    id: "v02",
    title: "街头即兴吉他弹唱，路人纷纷驻足",
    categoryId: "music",
    categoryName: "音乐",
    cover: "https://readdy.ai/api/search-image?query=warm%20stylized%20acoustic%20guitar%20close%20up%20on%20a%20sunset%20street%2C%20street%20musician%20busking%2C%20soft%20golden%20hour%20lighting%2C%20cinematic%20bokeh%20background%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-02&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=warm%20stylized%20acoustic%20guitar%20close%20up%20on%20a%20sunset%20street%2C%20street%20musician%20busking%2C%20soft%20golden%20hour%20lighting%2C%20cinematic%20bokeh%20background%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-02&orientation=landscape",
    duration: "01:12",
    plays: 876000,
    likes: 71500,
    author: "阿泽弹唱",
    publishedAt: "2026-10-10",
    description: "下班路上的一段即兴弹唱，没想到围了一圈人。音乐真的能让陌生人安静下来。",
    tags: ["吉他", "街头音乐", "翻唱"],
  },
  {
    id: "v03",
    title: "爆笑萌宠合集：猫狗行为的迷惑瞬间",
    categoryId: "funny",
    categoryName: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=playful%20fluffy%20kitten%20and%20puppy%20together%20on%20a%20soft%20pastel%20background%2C%20warm%20studio%20lighting%2C%20cute%20expressions%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-03&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=playful%20fluffy%20kitten%20and%20puppy%20together%20on%20a%20soft%20pastel%20background%2C%20warm%20studio%20lighting%2C%20cute%20expressions%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-03&orientation=landscape",
    duration: "00:36",
    plays: 2043000,
    likes: 168900,
    author: "铲屎官日记",
    publishedAt: "2026-10-13",
    description: "猫主子和狗子的迷惑行为大赏，看到最后一个我直接笑出声。",
    tags: ["萌宠", "搞笑", "合集"],
  },
  {
    id: "v04",
    title: "三分钟学会番茄炒蛋，拌饭神器",
    categoryId: "food",
    categoryName: "美食",
    cover: "https://readdy.ai/api/search-image?query=steaming%20tomato%20scrambled%20egg%20dish%20styled%20on%20a%20rustic%20wooden%20table%20with%20warm%20lighting%2C%20appetizing%20home%20cooking%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-04&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=steaming%20tomato%20scrambled%20egg%20dish%20styled%20on%20a%20rustic%20wooden%20table%20with%20warm%20lighting%2C%20appetizing%20home%20cooking%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-04&orientation=landscape",
    duration: "03:04",
    plays: 654000,
    likes: 58200,
    author: "一口小厨房",
    publishedAt: "2026-10-09",
    description: "很多人做不好番茄炒蛋，其实关键在火候和放糖的时机。跟着做零失败。",
    tags: ["家常菜", "教程", "快手菜"],
  },
  {
    id: "v05",
    title: "街舞battle高光时刻，全场沸腾",
    categoryId: "entertainment",
    categoryName: "娱乐",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20street%20dancer%20silhouette%20with%20motion%20blur%20and%20colorful%20stage%20lights%2C%20energetic%20dance%20battle%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-05&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=dynamic%20street%20dancer%20silhouette%20with%20motion%20blur%20and%20colorful%20stage%20lights%2C%20energetic%20dance%20battle%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-05&orientation=landscape",
    duration: "01:45",
    plays: 1567000,
    likes: 132400,
    author: "街舞前线",
    publishedAt: "2026-10-11",
    description: "两大队长的决胜局，最后一轮直接把评委看站起来了。",
    tags: ["街舞", "battle", "现场"],
  },
  {
    id: "v06",
    title: "治愈系海边日落，戴上耳机安静三分钟",
    categoryId: "life",
    categoryName: "生活",
    cover: "https://readdy.ai/api/search-image?query=calm%20ocean%20waves%20at%20golden%20sunset%20with%20soft%20pastel%20sky%2C%20peaceful%20atmosphere%2C%20gentle%20reflections%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-06&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=calm%20ocean%20waves%20at%20golden%20sunset%20with%20soft%20pastel%20sky%2C%20peaceful%20atmosphere%2C%20gentle%20reflections%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-06&orientation=landscape",
    duration: "03:20",
    plays: 512000,
    likes: 63400,
    author: "漫游日记",
    publishedAt: "2026-10-08",
    description: "工作累了就看看海吧。没有解说，没有BGM，只有海浪的声音。",
    tags: ["治愈", "旅行", "海景"],
  },
  {
    id: "v07",
    title: "电音REMIX混音现场，心跳跟着节奏走",
    categoryId: "music",
    categoryName: "音乐",
    cover: "https://readdy.ai/api/search-image?query=dj%20console%20with%20glowing%20knobs%20in%20a%20dark%20club%20with%20warm%20red%20lights%2C%20energetic%20electronic%20music%20scene%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-07&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=dj%20console%20with%20glowing%20knobs%20in%20a%20dark%20club%20with%20warm%20red%20lights%2C%20energetic%20electronic%20music%20scene%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-07&orientation=landscape",
    duration: "02:18",
    plays: 743000,
    likes: 66900,
    author: "DJ 阿浪",
    publishedAt: "2026-10-07",
    description: "把三首经典老歌串成一段电音，副歌一进来全场就炸了。",
    tags: ["电音", "remix", "混音"],
  },
  {
    id: "v08",
    title: "悬疑短剧《深夜来电》，结局反转",
    categoryId: "entertainment",
    categoryName: "娱乐",
    cover: "https://readdy.ai/api/search-image?query=moody%20glowing%20smartphone%20screen%20in%20a%20dark%20room%2C%20mysterious%20suspense%20atmosphere%2C%20warm%20rim%20light%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-08&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=moody%20glowing%20smartphone%20screen%20in%20a%20dark%20room%2C%20mysterious%20suspense%20atmosphere%2C%20warm%20rim%20light%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-08&orientation=landscape",
    duration: "04:02",
    plays: 986000,
    likes: 88400,
    author: "午夜剧场",
    publishedAt: "2026-10-06",
    description: "深夜两点，一个陌生来电把女主拉进了十年前的旧事里。看到最后你绝对猜不到。",
    tags: ["短剧", "悬疑", "反转"],
  },
  {
    id: "v09",
    title: "山野露营过夜全记录，篝火与星空",
    categoryId: "life",
    categoryName: "生活",
    cover: "https://readdy.ai/api/search-image?query=cozy%20tent%20glowing%20at%20night%20in%20a%20mountain%20forest%20with%20a%20campfire%2C%20starry%20sky%2C%20warm%20inviting%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-09&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=cozy%20tent%20glowing%20at%20night%20in%20a%20mountain%20forest%20with%20a%20campfire%2C%20starry%20sky%2C%20warm%20inviting%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-09&orientation=landscape",
    duration: "05:16",
    plays: 468000,
    likes: 47300,
    author: "山野旅人",
    publishedAt: "2026-10-05",
    description: "背上帐篷去山里住一晚，信号没了，心却安静了。附完整装备清单。",
    tags: ["露营", "户外", "vlog"],
  },
  {
    id: "v10",
    title: "手工陶瓷拉坯全过程，治愈解压",
    categoryId: "life",
    categoryName: "生活",
    cover: "https://readdy.ai/api/search-image?query=hands%20shaping%20clay%20on%20a%20spinning%20pottery%20wheel%2C%20warm%20studio%20lighting%2C%20calm%20craft%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-10&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=hands%20shaping%20clay%20on%20a%20spinning%20pottery%20wheel%2C%20warm%20studio%20lighting%2C%20calm%20craft%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-10&orientation=landscape",
    duration: "06:30",
    plays: 392000,
    likes: 41800,
    author: "陶艺小铺",
    publishedAt: "2026-10-04",
    description: "从一团泥到一只杯子，看着它慢慢成形，真的很解压。",
    tags: ["手工", "陶瓷", "解压"],
  },
  {
    id: "v11",
    title: "古风编曲《青云志》，古筝一响惊艳全场",
    categoryId: "music",
    categoryName: "音乐",
    cover: "https://readdy.ai/api/search-image?query=traditional%20chinese%20guzheng%20instrument%20with%20falling%20petals%2C%20elegant%20warm%20lighting%2C%20serene%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-11&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=traditional%20chinese%20guzheng%20instrument%20with%20falling%20petals%2C%20elegant%20warm%20lighting%2C%20serene%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-11&orientation=landscape",
    duration: "03:48",
    plays: 821000,
    likes: 79300,
    author: "青弦古乐",
    publishedAt: "2026-10-03",
    description: "原创古风曲《青云志》完整版，古筝与笛声交织，听完像看了一场江湖。",
    tags: ["古风", "古筝", "原创"],
  },
  {
    id: "v12",
    title: "办公室沙雕日常，条条戳中打工人",
    categoryId: "funny",
    categoryName: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=humorous%20office%20desk%20scene%20with%20coffee%20and%20colorful%20sticky%20notes%2C%20warm%20tone%2C%20playful%20mood%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-12&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=humorous%20office%20desk%20scene%20with%20coffee%20and%20colorful%20sticky%20notes%2C%20warm%20tone%2C%20playful%20mood%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-12&orientation=landscape",
    duration: "01:28",
    plays: 1132000,
    likes: 96400,
    author: "打工人观察局",
    publishedAt: "2026-10-02",
    description: "当同事说“就改一小下”的时候，我的内心是这样的。",
    tags: ["搞笑", "职场", "段子"],
  },
  {
    id: "v13",
    title: "峡谷五杀精彩集锦，操作拉满",
    categoryId: "game",
    categoryName: "游戏",
    cover: "https://readdy.ai/api/search-image?query=dramatic%20game%20controller%20with%20neon%20glow%20on%20a%20dark%20desk%2C%20esports%20gaming%20atmosphere%2C%20warm%20accent%20lighting%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-13&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=dramatic%20game%20controller%20with%20neon%20glow%20on%20a%20dark%20desk%2C%20esports%20gaming%20atmosphere%2C%20warm%20accent%20lighting%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-13&orientation=landscape",
    duration: "04:44",
    plays: 687000,
    likes: 71200,
    author: "峡谷指挥官",
    publishedAt: "2026-10-01",
    description: "残血反打五杀，这一波操作我自己都看傻了。慢放解析在最后。",
    tags: ["电竞", "高光", "五杀"],
  },
  {
    id: "v14",
    title: "深夜食堂：香辣小龙虾的正确打开方式",
    categoryId: "food",
    categoryName: "美食",
    cover: "https://readdy.ai/api/search-image?query=spicy%20red%20crayfish%20platter%20with%20steam%20on%20a%20dark%20table%2C%20appetizing%20food%20photography%2C%20warm%20lighting%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-14&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=spicy%20red%20crayfish%20platter%20with%20steam%20on%20a%20dark%20table%2C%20appetizing%20food%20photography%2C%20warm%20lighting%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-14&orientation=landscape",
    duration: "02:52",
    plays: 578000,
    likes: 52600,
    author: "深夜放毒",
    publishedAt: "2026-09-30",
    description: "小龙虾配啤酒，才是夏天的仪式感。今天教你调出餐厅同款底料。",
    tags: ["夜宵", "小龙虾", "探店"],
  },
  {
    id: "v15",
    title: "综艺名场面盘点，笑到停不下来",
    categoryId: "entertainment",
    categoryName: "娱乐",
    cover: "https://readdy.ai/api/search-image?query=colorful%20tv%20stage%20with%20spotlights%20and%20confetti%2C%20energetic%20entertainment%20show%20atmosphere%2C%20warm%20tones%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-15&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=colorful%20tv%20stage%20with%20spotlights%20and%20confetti%2C%20energetic%20entertainment%20show%20atmosphere%2C%20warm%20tones%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-15&orientation=landscape",
    duration: "05:08",
    plays: 902000,
    likes: 84700,
    author: "综艺速报",
    publishedAt: "2026-09-29",
    description: "盘点本季度最出圈的综艺名场面，每一个都值得反复观看。",
    tags: ["综艺", "名场面", "盘点"],
  },
  {
    id: "v16",
    title: "夜市探店：藏在巷子里的宝藏小吃",
    categoryId: "food",
    categoryName: "美食",
    cover: "https://readdy.ai/api/search-image?query=street%20food%20stall%20at%20a%20night%20market%20with%20warm%20lanterns%2C%20cozy%20lively%20atmosphere%2C%20appetizing%20food%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-16&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=street%20food%20stall%20at%20a%20night%20market%20with%20warm%20lanterns%2C%20cozy%20lively%20atmosphere%2C%20appetizing%20food%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-16&orientation=landscape",
    duration: "06:12",
    plays: 431000,
    likes: 39900,
    author: "干饭地图",
    publishedAt: "2026-09-28",
    description: "跟着本地人钻巷子，找到三家连招牌都没有的小吃摊，全都不踩雷。",
    tags: ["探店", "夜市", "小吃"],
  },
  {
    id: "v17",
    title: "沙雕动物迷惑行为，最后一只笑翻",
    categoryId: "funny",
    categoryName: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=silly%20cat%20mid%20jump%20with%20a%20surprised%20expression%20on%20a%20clean%20background%2C%20playful%20humor%2C%20warm%20lighting%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-17&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=silly%20cat%20mid%20jump%20with%20a%20surprised%20expression%20on%20a%20clean%20background%2C%20playful%20humor%2C%20warm%20lighting%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-17&orientation=landscape",
    duration: "00:52",
    plays: 1345000,
    likes: 119800,
    author: "动物观察站",
    publishedAt: "2026-09-27",
    description: "动物们的迷惑行为合集，第7秒那只猫我真的没忍住。",
    tags: ["动物", "搞笑", "合集"],
  },
  {
    id: "v18",
    title: "单机游戏速通挑战，一小时极限通关",
    categoryId: "game",
    categoryName: "游戏",
    cover: "https://readdy.ai/api/search-image?query=retro%20arcade%20game%20screen%20glow%20with%20player%20hands%20on%20a%20controller%2C%20warm%20neon%20accents%2C%20nostalgic%20gaming%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=640&height=360&seq=vd91-cover-18&orientation=landscape",
    hero: "https://readdy.ai/api/search-image?query=retro%20arcade%20game%20screen%20glow%20with%20player%20hands%20on%20a%20controller%2C%20warm%20neon%20accents%2C%20nostalgic%20gaming%20atmosphere%2C%20modern%20social%20media%20poster%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1280&height=720&seq=vd91-hero-18&orientation=landscape",
    duration: "08:24",
    plays: 356000,
    likes: 38400,
    author: "速通老张",
    publishedAt: "2026-09-26",
    description: "练了三个月，终于把速通时间压到了一小时以内，全程无剪辑。",
    tags: ["速通", "挑战", "单机"],
  },
];